import { ComponentProps, forwardRef } from "react";
import { cn } from "../../../lib/utils";
import { InputLabel } from "./input-label";

export type TAppTextareaProps = ComponentProps<"textarea"> & {
  textareaError?: string;
  containerClassName?: string;
  label?: string;
  fullWidth?: boolean;
  isOptional?: boolean;
};

export const AppTextarea = forwardRef<HTMLTextAreaElement, TAppTextareaProps>(function AppTextarea(props, ref) {
  const { className, textareaError, containerClassName, label, fullWidth = false, isOptional, ...otherProps } = props;
  return (
    <label
      className={cn(
        "flex flex-col gap-[1px] relative",
        fullWidth ? "w-full" : "inline-flex w-fit",
        otherProps.disabled && "pointer-events-none cursor-not-allowed opacity-50",
        containerClassName
      )}
      data-slot="input-wrapper"
    >
      {label && (
        <InputLabel isOptional={isOptional} className="mb-2">
          {label}
        </InputLabel>
      )}
      <textarea
        ref={ref}
        data-slot="textarea"
        className={cn(
          "border border-innoveraZinc-150 placeholder:text-innoveraZinc-400 text-innoveraZinc-900 h-[32px] min-w-0",
          fullWidth && "w-full",
          "rounded-[8px] bg-transparent text-[14px] leading-[22px] px-3 py-2 transition-shadow duration-300 ease outline-none",
          "hover:ring-2 hover:ring-innoveraZinc-150 focus-visible:ring-2 focus-visible:ring-innoveraZinc-150",
          !!textareaError && "border-innoveraRed-400 hover:ring-innoveraRed-50 focus-visible:ring-innoveraRed-50",
          className
        )}
        {...otherProps}
      />

      {textareaError && (
        <p className="absolute bottom-[-14px] left-1 text-innoveraRed-400 text-[10px]">{textareaError}</p>
      )}
    </label>
  );
});

AppTextarea.displayName = "AppTextarea";
